"use client";
import React, { useMemo, useState } from "react";

import { useProductDetailsContext } from "@/src/provider";
import { FmButton } from "@/ui-component";
import { productDetailsStore } from "@/store/pageModules";
import classnames from "classnames";
import stl from "./productImgSwiper.module.scss";
import { useTranslation } from "@/src/i18n/client";

interface IProps {}

const ShowAIClient: React.FC<React.PropsWithChildren<IProps>> = (props) => {
    const [tipShow, setTipShow] = useState(false);
    const [productDetail, productImgList, modelImgList, video] =
        useProductDetailsContext((state) => [
            state.productDetail,
            state.productImgList,
            state.modelImgList,
            state.video,
        ]);
    const [swiperIndex] = productDetailsStore.useProdcutDetailsStore(
        (state) => [state.swiperIndex],
    );
    const { t } = useTranslation("productDetail");
    const onToggerAiTip = () => {
        setTipShow((prev) => !prev);
    };
    const isShowAi = useMemo(() => {
        if (swiperIndex + 1 > productImgList.length) {
            let model =
                productDetail.products_model_show?.[
                    swiperIndex - productImgList.length
                ];
            return model ? model.is_ai_generate === 1 : false;
        }
    }, [productDetail.products_model_show, productImgList.length, swiperIndex]);

    return (
        isShowAi && (
            <div className={stl["ai-btn"]}>
                <div
                    className={classnames(
                        "default_layout",
                        stl["show-ai-wrapper"],
                    )}
                >
                    <FmButton onClick={onToggerAiTip} variant="text">
                        {props.children}
                    </FmButton>
                    <div
                        className={classnames(stl["tip-content"], {
                            [stl["tip-show"]]: tipShow,
                        })}
                    >
                        <div>{t("productDetail:AI_TIP")}</div>
                    </div>
                </div>
            </div>
        )
    );
};

export default ShowAIClient;
